export default __webpack_public_path__ + "static/media/france.f542aafb.svg";